// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__yg-vc"};